import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Collapse,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import {
  Edit,
  Delete,
  DeleteForever,
  AddAlarm,
  AccessAlarm,
} from '@material-ui/icons/';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";
import dayjs from "dayjs";
dayjs.locale("ja");

import isOnReservation from "fuction/isOnReservation";

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "105px",
  },
  limitCol: {
    textAlign: "center",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },

}));

function Users(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [users, setUsers] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [deleteAt, setDeleteAt] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - アカウント管理";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
    if (props.location.search.indexOf("delete") > -1) {
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchUsers();
  }, [auth.state.token]);

  const fetchUsers = () => {
    request({
      method: "GET",
      url: `admin/accounts`,
    }).then((result) => {
      setUsers(result.data.data);
    });
  };

  const onClickEditButton = (id) => {
    props.history.push(`/admin/account/edit/${id}`);
  };

  const onClickReserveButton = (accountId, reserveId) => {
    props.history.push(`/admin/account/reserve/${accountId}/${reserveId}`);
  };

  const openDialog = (id, date) => {
    setDeleteId(id);
    setDeleteAt(date);
    setIsShowModal(true);
  };

  const deleteUser = () => {
    request({
      method: "DELETE",
      url: `admin/accounts/${deleteId}`,
    }).then(() => {
      fetchUsers();
      setIsShowModal(false);
    });
  };

  const cancelDeleteUser = () => {
    request({
      method: "DELETE",
      url: `admin/accounts/${deleteId}/cancel`,
    }).then(() => {
      fetchUsers();
      setIsShowModal(false);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 1 ? false : true ;
    const [open, setOpen] = React.useState(false);
    // 増量オプション自動適用の更新予約状態判定
    const isReservation = isOnReservation(row.contract_type, row.limit_exceed.enable, row.max_current, row.max_tweets, row.limit_exceed.remain);

    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.master.email}</TableCell>
          <TableCell>{row.contract_type}</TableCell>
          <TableCell>{row.connected_at ? '〇' : '×'}</TableCell>
          <TableCell>{row.reserve_id ? '〇' : '×'}</TableCell>
          <TableCell className={classes.dateCol}>{dayjs(row.created_at).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell className={classes.dateCol}>{row.updated_at ? dayjs(row.updated_at).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell className={classes.dateCol}>{row.deleted_at ? dayjs(row.deleted_at).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell>
            <IconButton
              color="primary"
              aria-label="add an Edit"
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            {row.deleted_at ?
              <IconButton
                color="secondary"
                aria-label="add an DeleteForever"
                onClick={() => openDialog(row.id, row.deleted_at)}
              >
                <DeleteForever />
              </IconButton> :
              <IconButton
                className={classes.buttonRed}
                aria-label="add an Delete"
                onClick={() => openDialog(row.id, row.deleted_at)}
              >
                <Delete />
              </IconButton>
            }
            {row.reserve_id ?
              <IconButton
                color="primary"
                aria-label="add an AccessAlarm"
                onClick={() => onClickReserveButton(row.id, row.reserve_id)}
              >
                <AccessAlarm />
              </IconButton> :
              <IconButton
                color="secondary"
                aria-label="add an AddAlarm"
                onClick={() => onClickReserveButton(row.id, 0)}
              >
                <AddAlarm />
              </IconButton>
            }
          </TableCell>
        </TableRow>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>KW数</TableCell>
                      <TableCell>上限(基本)</TableCell>
                      <TableCell>上限(当月)</TableCell>
                      <TableCell>データプール</TableCell>
                      <TableCell>自動適用</TableCell>
                      <TableCell>収集G数</TableCell>
                      <TableCell>開始日時</TableCell>
                      <TableCell>終了日時</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{row.num_words.current}/{row.num_words.limit}</TableCell>
                      <TableCell>{row.max_tweets}</TableCell>
                      <TableCell>{row.max_current}</TableCell>
                      <TableCell>{row.limit_exceed.remain}</TableCell>
                      <TableCell>
                        {row.limit_exceed.enable
                          ? isReservation ? "〇（予約中）" : "〇"
                          : isReservation ? "×（予約中）" : "×"
                        }
                      </TableCell>
                      <TableCell>{row.num_groups.current}/{row.num_groups.limit}</TableCell>
                      <TableCell>{row.valid_from ? dayjs(row.valid_from).format("YYYY/MM/DD HH:mm:ss") : "-"}</TableCell>
                      <TableCell>{row.valid_until ? dayjs(row.valid_until).format("YYYY/MM/DD HH:mm:ss") : "-"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>名前</TableCell>
                    <TableCell>マスターアドレス</TableCell>
                    <TableCell>タイプ</TableCell>
                    <TableCell>接続中</TableCell>
                    <TableCell>変更<br />予約</TableCell>
                    <TableCell>作成日</TableCell>
                    <TableCell>更新日</TableCell>
                    <TableCell>削除日</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(
                    function (row, index) {
                      return <Row key={row.id} index={index} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => props.history.push(`/admin/account/create`)}
              >
                新規アカウント登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                { !deleteAt ? "本当に削除してよろしいですか？" : "本当に復活してよろしいですか？" }
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={ !deleteAt ? deleteUser : cancelDeleteUser }>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Users);
